import { DEMO_MAILTO, PRODUCT_NAME_FULL } from "@/config";
import { ribbonLight } from "../../../brand/wordmark";

export function Footer() {
  return (
    <footer style={{ padding: "0 24px 40px" }}>
      <div style={{ maxWidth: "1120px", margin: "0 auto", borderTop: "1px solid rgba(var(--ink-rgb),.1)", paddingTop: "28px", display: "flex", flexWrap: "wrap", alignItems: "center", gap: "18px 32px" }}>
        <img className="ribbon-wordmark" src={ribbonLight} alt={PRODUCT_NAME_FULL} width={300} height={100} />
        <span style={{ fontSize: "13.5px", color: "var(--muted-2)" }}>Das Cockpit für Catering-Anfragen.</span>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "24px", flexWrap: "wrap" }}>
          <a className="footer-link" href={DEMO_MAILTO}>Kontakt</a>
          <a className="footer-link" href="#">Impressum</a>
          <a className="footer-link" href="#">Datenschutz</a>
        </div>
        <p style={{ flexBasis: "100%", margin: "6px 0 0", fontSize: "12.5px", color: "var(--faint)" }}>© 2026 {PRODUCT_NAME_FULL}. Alle Rechte vorbehalten.</p>
      </div>
    </footer>
  );
}
